import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Center } from '@myphx-engineering/phx-design-system';

const NotFoundPage = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    // instrument error state
    // oxlint-disable-next-line no-console
    console.error('Navigated to unknown route: ', pathname);

    return <Center p="md">{t('notFound.pageNotFound')}</Center>;
};

export default NotFoundPage;
